import { render, staticRenderFns } from "./CompanyEvents.vue?vue&type=template&id=ab7a7810"
import script from "./CompanyEvents.vue?vue&type=script&lang=js"
export * from "./CompanyEvents.vue?vue&type=script&lang=js"
import style0 from "./CompanyEvents.vue?vue&type=style&index=0&id=ab7a7810&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports